import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { BaasRemark } from '../baas-remark/baas-remark';
import { BaasRemarkOptions } from '../baas-remark-options.type';

@Component({
    selector: 'baas-remark-list',
    templateUrl: './baas-remark-list.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BaasRemark]
})
/** Represents a single remark */
export class BaasRemarkList {
    readonly remarks = input<BaasRemarkOptions[]>();
    readonly autoSort = input(true);

    protected readonly remarkList = computed(() => {
        const result = this.remarks() == null ? [] : [...this.remarks()];
        if (this.autoSort()) {
            result.sort((a, b) => {
                if (a.type === b.type) {
                    return 0;
                } else if (a.type === 'blocking' || b.type === 'info') {
                    return -1;
                } else {
                    return 1;
                }
            });
        }
        return result;
    });
}
